import { computeHealthPriority } from '../utils.js';

class Serializer {
  normalize = data => {
    let props = data.properties || {};
    return {
      id: data.node.nodeAddress,
      health: data.health,
      nodeAddress: data.node.nodeAddress,
      nodeName: data.node.nodeName,
      accessPointsCount: props.accessPointsCount,
      siteId: data.node.assetInfo.metadata.props.siteId,
      downtime: props.downtime,
      healthPriority: computeHealthPriority(data.health)
    };
  };
}

export const GatewaySerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/status/gateway/index.js